import { useState, useRef } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import LogoutButton from "./LogoutButton";
import { useAuth } from "../../contexts/AuthContext";
import UserRoleChip from "./UserRoleChip";

const stringToColor = (string) => {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = `hsl(${hash % 360}, 60%, 50%)`;
  return color;
};

export default function AccountPopover() {
  const { user, isAdmin } = useAuth();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          px: 1,
        }}
      >
        <Avatar
          src={user?.profileImage}
          alt={user?.name}
          sx={{
            width: 40,
            height: 40,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
            bgcolor: !user?.profileImage
              ? stringToColor(user?.name || user?.email || "U")
              : "transparent",
            color: "#fff",
            border: "5px solid #EAEAEA",
          }}
        >
          {user?.name?.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        modifiers={[
          {
            name: "offset",
            // options: {
            //   offset: [0, 10],
            // },
          },
        ]}
        sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Box>
            <ArrowDropUpIcon
              fontSize="medium"
              sx={{
                position: "absolute",
                top: -14,
                right: 12,
                color: "background.paper",
              }}
            />

            <Paper
              sx={{
                minWidth: 220,
                boxShadow:
                  "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px",
                textAlign: "center",
                borderRadius: 2,
              }}
            >
              <Box sx={{ p: 1, py: 2 }}>
                {user?.name && (
                  <Typography variant="subtitle2" fontWeight="bold">
                    {user.name}
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary" }}
                  noWrap
                >
                  {user?.email}
                </Typography>
              </Box>

              {/* <UserRoleChip /> */}

              <Divider sx={{ borderStyle: "dashed" }} />
              <Box sx={{ p: 1, py: 2 }}>
                <LogoutButton
                  showText
                  variant="text"
                  sx={{
                    bgcolor: "#fff4f4",
                    px: 2,
                    ":hover": {
                      bgcolor: "#FBE5E5",
                    },
                  }}
                />
              </Box>
            </Paper>
          </Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
}
